import { Random } from './util';

const shareTextData = [
  '这份DNF“高考卷”请查收，看看你能拿多少分？',
  'DNF答题大比拼，一起来证明你是DNF的忠实粉丝',
  '这份DNF玩家专属答卷请收好，看看你能拿多少分',
  '一起来参加DNF答题大比拼，测测你对阿拉德了解到底有多深',
  'DNF知识大比拼，看看谁才是阿拉德“懂王”',
  '快来参加DNF答题大挑战，看你能否满血通关',
  '我挑战了DNF知识大比拼，击败了98%的玩家，快来看看你能击败多少',
  'DNF知识问答大挑战，看你能否回顾所有关于阿拉德大陆的事？',
  '快来参加DNF答题大挑战，争做阿拉德第一“懂王”',
  '阿拉德大陆知多少？快来参加DNF问答，看看你能得几分',
  '你知道那些角色是CP吗？来DNF知识大比拼，看看谁才是答题王！',
  '鬼剑士为何要带锁链？神枪手到底是不是近视？来DNF知识大比拼揭开这些秘密吧~',
  '奈雅丽和次元行者到底是什么关系？快来DNF答题大比拼你就知道了~',
  '阿拉德知名“舔狗”是谁？正太诺顿是哪个版本的？DNF答题王，一切答案都在这',
  '合金战士需不需要上厕所？来DNF答题王，你想知道的全都有',
  '墨竹梵风原来值这么多钱！当年你有被骗过吗？快来DNF答题王见分晓！',
  '去找吧！我把所有的答案都放在那里！DNF答题王等你来挑战！',
  '罐子头红翅膀是哪个职业的“校服”？这些远古老梗你都知道吗？快来DNF答题王看看吧',
  'GSD是什么职业？GBL教全称又是什么？快来测测谁才是真正的“老玩家”。',
  '穿上西装打领带，打团答题我最帅',
  '90分以上才敢自称老玩家，DNF答题王等你来挑战',
  '谁是真的15年老玩家？DNF答题王一测便知',
  '谁才是阿拉德的“万事通”？快来DNF答题王挑战看看吧~',
  '你对阿拉德大陆有多了解？快来DNF答题王测试看看吧',
  '老勇士还是云万家？DNF答题王分数上见分晓！',
  '这都不知道还敢自称“老玩家”？这些问题你都知道吗？',
  '谁才是DNF的“问答之王”？快来测试看看吧~',
  '流星落全名是什么？魔剑卡又是什么？答案都在DNF答题王！',
  '真假老玩家一测便知！艾特你列表里的勇士参加吧~',
  '才这种程度？90分以上才配自称老玩家！快来DNF答题王试试吧',
];

export const ShareText = () => {
  return shareTextData[Random(shareTextData.length - 1)];
};

const shareBgData = [
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-1.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-2.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-3.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-4.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-5.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-6.png/ori_png',
  'https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/share-bg-7.png/ori_png',
];

export const shareBgSrc = () => {
  return shareBgData[Random(shareBgData.length - 1)];
};
